import React from 'react';
import ReactDOM from 'react-dom/client';

import WebcamCollection from './WebcamCollection';

const root = ReactDOM.createRoot(document.getElementById('webcam_collection'));

root.render(
  <React.StrictMode>
    <WebcamCollection />
  </React.StrictMode>
);
